import { Badge, Icon } from 'AWS-UI-Components-React';
import { SimulationStatusTypes } from '../../constants/constants';

export function displayFlag(flag, positiveIconText, negativeIconText) {
  if (flag) {
    return (
      <span className="awsui-util-status-positive">
          <Icon name="status-positive" /> {positiveIconText ? positiveIconText : 'Yes'}
        </span>
    );
  } else {
    return (
      <span className="awsui-util-status-negative">
          <Icon name="status-negative" /> {negativeIconText ? negativeIconText : 'No'}
        </span>
    );
  }
}

export function displayStatusBadge(simulation) {
  let color = 'blue';
  let status = simulation.latestStatus;
  if (status && status.endsWith(SimulationStatusTypes.FAILED)) {
    color = 'red';
  } else if (status === SimulationStatusTypes.DONE) {
    color = 'green';
  }

  return (<div><Badge color={ color } content={ status } /></div>);
}

export function sorter(a, b) {
  if (a.timestamp === b.timestamp) {
    return 0;
  } else {
    return a.timestamp < b.timestamp ? 1 : -1;
  }
}

export function getFilteringOptions(simulations) {
  let nameOptions = new Set();
  let userOptions = new Set();
  let statusOptions = new Set();
  let dateOptions = new Set();
  if (simulations) {
    simulations.forEach(simulation => {
      if (simulation.name) {
        nameOptions.add(simulation.name);
      }
      if (simulation.user) {
        userOptions.add(simulation.user);
      }
      if (simulation.latestStatus) {
        statusOptions.add(simulation.latestStatus);
      }
      if (simulation.timestamp) {
        dateOptions.add(simulation.timestamp.substr(0, 10));
      }
    });
  }
  return [
    {
      groupValuesLabel: 'Name Values',
      propertyKey: 'name',
      propertyLabel: 'Name',
      values: Array.from(nameOptions),
    },
    {
      groupValuesLabel: 'User Values',
      propertyKey: 'user',
      propertyLabel: 'User',
      values: Array.from(userOptions),
    },
    {
      groupValuesLabel: 'Current Status Values',
      propertyKey: 'currentStatus',
      propertyLabel: 'Current Status',
      values: Array.from(statusOptions),
    },
    {
      groupValuesLabel: 'Date Option Values',
      propertyKey: 'timestamp',
      propertyLabel: 'Creation Date',
      values: Array.from(dateOptions),
    },
  ];
}

export function millisToMinutesAndSeconds(millis) {
  const minutes = Math.floor(millis / 60000);
  const seconds = ((millis % 60000) / 1000).toFixed(0);
  return minutes + ":" + (seconds < 10 ? '0' : '') + seconds;
}


// WEBPACK FOOTER //
// ./src/components/simulator/simulator_utils.jsx